import { useEffect } from 'react'
import { useTrackEvent } from './analytics'
import { setProductEventEmitter } from './productEvents'

/**
 * Publishes the surrounding event scope's emitter to `emitProductEvent`, so
 * Redux thunks can emit with the same identity metadata React callers get.
 * Mount once, inside the root `EventScopeProvider`.
 */
export const ProductEventEmitterBinding = () => {
  const track = useTrackEvent()

  useEffect(() => {
    setProductEventEmitter(track)
    return () => setProductEventEmitter(null)
  }, [track])

  return null
}
